import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
const API_KEY = '26b95077fec20f86665fb2529425f30b';
const SESSION_ENDPOINT = 'https://session.app-performance.music.amazon.dev';
const NOTIFICATION_ENDPOINT = 'https://events.app-performance.music.amazon.dev';
export function initBugsnag() {
    Bugsnag.start({
        apiKey: API_KEY,
        plugins: [new BugsnagPluginReact()],
        endpoints: {
            notify: NOTIFICATION_ENDPOINT,
            sessions: SESSION_ENDPOINT,
        },
    });
    const bugsnagReactPlugin = Bugsnag.getPlugin('react');
    return (bugsnagReactPlugin === null || bugsnagReactPlugin === void 0 ? void 0 : bugsnagReactPlugin.createErrorBoundary(React)) || React.Fragment;
}
